import { quickEntries } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function QuickEntries() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="快捷入口"
          title="想找什么，从这里直进"
          desc="测评、资料库、论坛、下载一站直达，省去在站内到处翻的时间。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {quickEntries.map((entry, index) => {
            const isDownload = entry.icon === "ri-download-2-line";
            return (
              <a
                key={entry.id}
                href={isDownload ? "#download" : "#forum"}
                className={`group flex flex-col rounded-lg border p-5 transition-colors ${
                  isDownload
                    ? "border-primary-600 bg-primary-500"
                    : "border-background-200 bg-background-50 hover:border-primary-300"
                }`}
                style={{ animationDelay: `${index * 60}ms` }}
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                      isDownload ? "bg-background-50/15 text-background-50" : "bg-primary-50 text-primary-600"
                    }`}
                  >
                    <i className={`${entry.icon} text-xl`} />
                  </span>
                  {entry.badge && (
                    <span
                      className={`rounded-full px-2.5 py-1 text-[11px] font-medium ${
                        isDownload
                          ? "bg-background-50 text-primary-700"
                          : "bg-accent-100 text-accent-800"
                      }`}
                    >
                      {entry.badge}
                    </span>
                  )}
                </div>
                <h3
                  className={`mt-4 font-heading text-base font-bold ${
                    isDownload ? "text-background-50" : "text-foreground-950"
                  }`}
                >
                  {entry.title}
                </h3>
                <p
                  className={`mt-2 flex-1 text-sm leading-relaxed ${
                    isDownload ? "text-background-50/80" : "text-foreground-600"
                  }`}
                >
                  {entry.desc}
                </p>
                <span
                  className={`mt-4 flex items-center gap-1.5 text-sm font-medium ${
                    isDownload ? "text-background-50" : "text-primary-600"
                  }`}
                >
                  {isDownload ? "立即下载" : "进入"}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}